import styled from "styled-components";

export const NudgeContainer = styled.div`
  ${(props) => props?.theme?.themeConfig?.nudge?.styles}
  top: -12px;
  right: -24px;

  @media (min-width: 768px) {
    right: 0;
    scale: 1;
    top: ${(props) => props?.theme?.themeConfig?.nudge?.styles.top}
  }
`
